import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import Layout from "../components/layout";
import { Row, Col, Carousel, Card, Calendar, Badge, Pagination } from "antd";
import Doctor from "../components/Doctor";
import { useDispatch } from "react-redux";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import imageSrc1 from "../components/image/appointment_1.jpeg";
import imageSrc2 from "../components/image/appointment_2.jpeg";
import imageSrc3 from "../components/image/appointment_3.jpeg";
import imageSrc4 from "../components/image/appointment_4.jpeg";
import dayjs from "dayjs";

const imgStyle = {
  width: "100%",
  height: "300px",
  objectFit: "cover",
  objectPosition: "center top",
};



function Home() {
  const [doctors, setDoctors] = useState([]);
  const [previousAppointments, setPreviousAppointments] = useState([]);
  const [pendingAppointments, setPendingAppointments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 6; // Number of doctors per page
  const dispatch = useDispatch();


    const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  // Pagination logic
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedDoctors = doctors.slice(startIndex, startIndex + pageSize);


  const getData = useCallback(async () => {
    try {
      dispatch(showLoading());

      const doctorsResponse = await axios.get("/api/user/get-all-approved-doctors", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      });

      if (doctorsResponse.data.success) {
        setDoctors(doctorsResponse.data.data);
      }

      const appointmentsResponse = await axios.get("/api/user/get-appointments-by-user-id", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      });

      if (appointmentsResponse.data.success) {
        const appointments = appointmentsResponse.data.data;
        setPreviousAppointments(appointments.filter((app) => app.status === "completed"));
        setPendingAppointments(appointments.filter((app) => app.status === "pending"));
      }

      dispatch(hideLoading());
    } catch (error) {
      console.error("Error fetching data:", error);
      dispatch(hideLoading());
    }
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [getData]);

  const getListData = (value) => {
    const currentDate = value.format("YYYY-MM-DD");
    let listData = [];

    const previous = previousAppointments.filter(
      (app) => dayjs(app.date).format("YYYY-MM-DD") === currentDate
    );
    listData.push(
      ...previous.map((app) => ({
        type: "success",
        content: `Dr. ${app.doctorInfo.firstName} (${app.status})`,
      }))
    );

    const pending = pendingAppointments.filter(
      (app) => dayjs(app.date).format("YYYY-MM-DD") === currentDate
    );
    listData.push(
      ...pending.map((app) => ({
        type: "processing",
        content: `Dr. ${app.doctorInfo.firstName} (${app.status})`,
      }))
    );

    return listData;
  };

  const dateCellRender = (value) => {
    const listData = getListData(value);
    return (
      <ul className="events">
        {listData.map((item, index) => (
          <li key={index}>
            <Badge status={item.type} text={item.content} />
          </li>
        ))}
      </ul>
    );
  };

  return (
    <Layout>
      <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
        <Carousel autoplay>
          {[imageSrc1, imageSrc2, imageSrc3, imageSrc4].map((src, index) => (
            <div key={index}>
              <img src={src} alt={`carousel_${index}`} style={imgStyle} />
            </div>
          ))}
        </Carousel>
      </div>

      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2>Book Appointment with Us</h2>
        <p>Schedule a consultation with our experienced doctors at your convenience.</p>
      </div>

      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <h2>Meet Our Doctors</h2>
      </div>
 <Row gutter={[20, 20]} style={{ maxWidth: "1000px", margin: "0 auto" }} className="p-6">
        {paginatedDoctors.map((doctor, index) => (
          <Col key={doctor._id || index} span={8} xs={24} lg={12}>
            <Doctor doctor={doctor} />
          </Col>
        ))}
      </Row>

      <Row justify="center" style={{ marginTop: 24 }}>
        <Pagination
          current={currentPage}
          total={doctors.length}
          pageSize={pageSize}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </Row>

      <Row gutter={[20, 20]} style={{ maxWidth: "1000px", margin: "0 auto" }}className="p-4">
        <Col xs={24}>
          <Card title="Appointments Calendar" bordered>
            <Calendar cellRender={dateCellRender} />
          </Card>
        </Col>
      </Row>

      <Row gutter={[20, 20]} style={{ maxWidth: "1000px", margin: "2rem auto" }}>
        <Col xs={24} sm={12}>
          <Card title="Previous Appointments" bordered>
            {previousAppointments.length > 0 ? (
              previousAppointments.map((app) => (
                <p className="normal-text" key={app._id}>
                  <b>
                    <i
                      className="ri-user-3-line"
                      style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}
                    ></i>
                    Doctor Name:
                  </b>{" "}
                  {app.doctorInfo.firstName}
                  <br />
                  <b>
                    <i
                      className="ri-calendar-event-line"
                      style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}
                    ></i>
                    Clinic Days:
                  </b>{" "}
                  {app.doctorInfo.clinicDay.map((day, index) => (
                    <span
                      key={index}
                      className="badge badge-light m-1"
                      style={{ color: "#217559", backgroundColor: "#f8f9fa" }}
                    >
                      {day}
                    </span>
                  ))}
                </p>
              ))
            ) : (
              <p>No previous appointments.</p>
            )}
          </Card>
        </Col>

        <Col xs={24} sm={12}>
          <Card title="Pending Appointments" bordered>
            {pendingAppointments.length > 0 ? (
              pendingAppointments.map((app) => (
                <p className="normal-text" key={app._id}>
                  <b>
                    <i
                      className="ri-user-3-line"
                      style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}
                    ></i>
                    Doctor Name:
                  </b>{" "}
                  {app.doctorInfo.firstName}
                  <br />
                  <b>
                    <i
                      className="ri-calendar-event-line"
                      style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}
                    ></i>
                    Clinic Days:
                  </b>{" "}
                  {app.doctorInfo.clinicDay.map((day, index) => (
                    <span
                      key={index}
                      className="badge badge-light m-1"
                      style={{ color: "#217559", backgroundColor: "#f8f9fa" }}
                    >
                      {day}
                    </span>
                  ))}
                </p>
              ))
            ) : (
              <p>No pending appointments.</p>
            )}
          </Card>
        </Col>
      </Row>
    </Layout>
  );
}

export default Home;
